import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import PropSearch from './pages/PropSearch';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/prop-search" element={<PropSearch />} />
      </Routes>
    </Router>
  );
}

export default App;
